/**
 * ============================================================================
 *  SITE CONFIGURATION
 * ----------------------------------------------------------------------------
 *  Edit the values below to rebrand this template. These are the main knobs
 *  used across the app (header, footer, SEO, contact, payment page, etc.).
 * ============================================================================
 */

export const siteConfig = {
  brand: {
    name: 'Flash USDT Software',
    tagline: 'Flash USDT Software — Secure, Fast, Reliable',
    description:
      'Flash USDT Software is the most reliable USDT flashing solution. Flash up to $10,000,000 USDT daily with our secure, tradable, swappable, and transferable flash USDT software.',
  },

  domain: 'https://flashusdtsoftware.blog',

  contact: {
    orderEmail: 'usdtflasherpro@gmail.com',
    supportEmail: 'usdtflasherpro@gmail.com',
    whatsapp: '447514003077',
    phoneDisplay: '+44 7514 003077',
  },

  social: {
    twitter: 'https://twitter.com/yourbrand',
    facebook: 'https://facebook.com/yourbrand',
    instagram: 'https://instagram.com/yourbrand',
    telegram: 'https://t.me/yourbrand',
  },

  payment: {
    wallets: {
      bitcoin: 'bc1quxlnwycepgm9d3zspwvmgljs0fwjv057cd2v2n',
      usdt: 'TN9trtRud3EuCioyUGPYoYZm9hU1dPFeew',
    },
  },
};

export default siteConfig;
